export default __webpack_public_path__ + "static/creative-39837b8949340ba8ac6865ccce3db443.jpg";